import React from "react";
import { ExpandedAccordion } from "../../../../shared/components/ui/ExpandedAccordion";
import { StatusBadge } from "../../../../shared/components/badges/StatusBadge";

const formatDate = (dateString) => {
  if (!dateString) return "—";
  return new Date(dateString).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatDateTime = (dateString) => {
  if (!dateString) return "—";
  return new Date(dateString).toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const formatCurrency = (value) => {
  if (!value && value !== 0) return "—";
  return `₹${parseFloat(value).toLocaleString("en-IN")}`;
};

const formatQualityCheck = (value) => {
  const labels = { PENDING: "Pending", PASSED: "Passed", FAILED: "Failed" };
  return labels[value] || value || "—";
};

const VaccineDispatchExpandRow = ({ item }) => {
  console.log("🚀 ~ VaccineDispatchExpandRow ~ item:", item);

  const sections = [
    {
      id: "vaccine-details",
      title: "Vaccine Details",
      fields: [
        { label: "Vaccine Name", value: item.vaccine?.name || item.vaccineName || "—" },
        { label: "Batch Number", value: item.batchNumber || "—" },
        { label: "Manufacturer/Supplier", value: item.manufacturer?.supplierName || item.supplierName || "—" },
        { label: "Quantity Dispatched", value: item.quantityDispatched ? `${item.quantityDispatched} units` : "—" },
        { label: "Price per Unit", value: formatCurrency(item.price) },
        { label: "Total Amount", value: formatCurrency(item.totalAmount) },
        { label: "Invoice Number", value: item.invoiceNo || "—" },
        { label: "Manufacturing Date", value: formatDate(item.manufacturingDate) },
        { label: "Expiry Date", value: formatDate(item.expiryDate) },
        { label: "Transfer Status", value: <StatusBadge status={item.transferStatus || "PENDING"} /> },
        { label: "Status", value: <StatusBadge status={item.status || "PENDING"} /> },
      ],
    },
    {
      id: "route-info",
      title: "Route Information",
      fields: [
        { label: "From Location", value: item.fromLocation?.name || item.fromCenterName || "—" },
        { label: "To Location", value: item.toLocation?.name || item.toCenterName || "—" },
        { label: "Dispatched On", value: formatDateTime(item.dispatchedOn) },
        { label: "Expected Delivery", value: formatDate(item.expectedDeliveryDate) },
        { label: "Courier Name", value: item.courierName || "—" },
        { label: "Tracking Number", value: item.trackingNumber || "—" },
      ],
    },
    {
      id: "handling-storage",
      title: "Handling & Storage",
      fields: [
        { label: "Packaging Type", value: item.packagingType || "—" },
        { label: "Storage Condition", value: item.storageCondition || "—" },
        { label: "Temperature at Dispatch", value: item.temperatureAtDispatch ? `${item.temperatureAtDispatch}°C` : "—" },
        { label: "Cold Chain Maintained", value: item.coldChainMaintained ? "Yes" : "No" },
        { label: "Dispatch Remarks", value: item.dispatchRemarks || "—", isLong: true },
      ],
    },
    {
      id: "receive-info",
      title: "Receive Information",
      fields: [
        { label: "Received On", value: formatDateTime(item.receivedOn) },
        { label: "Received By", value: item.receivedBy || "—" },
        { label: "Quantity Received", value: item.quantityReceived ? `${item.quantityReceived} units` : "—" },
        { label: "Quantity Accepted", value: item.quantityAccepted ? `${item.quantityAccepted} units` : "—" },
        { label: "Quantity Rejected", value: item.quantityRejected ? `${item.quantityRejected} units` : "—" },
        { label: "Temperature at Receive", value: item.temperatureAtReceive ? `${item.temperatureAtReceive}°C` : "—" },
        { label: "Quality Check", value: formatQualityCheck(item.qualityCheck) },
        { label: "Receive Remarks", value: item.receiveRemarks || "—", isLong: true },
      ],
    },
    {
      id: "inspection-info",
      title: "Inspection Information",
      fields: [
        { label: "Inspected On", value: formatDateTime(item.inspectedOn) },
        { label: "Inspected By", value: item.inspector?.fullName || "—" },
        { label: "Inspection Quality Check", value: formatQualityCheck(item.inspectedQualityCheck) },
        { label: "Inspection Remarks", value: item.insepectedRemarks || "—", isLong: true },
      ],
    },
  ];

  return <ExpandedAccordion sections={sections} />;
};

export default VaccineDispatchExpandRow;
